import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { browserHistory, Router } from 'react-router'

/** intl **/
import { addLocaleData, IntlProvider } from 'react-intl'
import fr from 'react-intl/locale-data/fr'
import en from 'react-intl/locale-data/en'
import de from 'react-intl/locale-data/de'
import es from 'react-intl/locale-data/es'
import it from 'react-intl/locale-data/it'
import pl from 'react-intl/locale-data/pl'
import * as QbMessages from './messages'

/** React routes et store **/
import { syncHistoryWithStore } from 'react-router-redux'
import configureStore from './store/configureStore'
import routesFactory from './routes'

/** utils **/
import injectTapEventPlugin from 'react-tap-event-plugin'

/** CSS **/
import './resources/css/style.css'
import './resources/css/qobuz-picto.css'
import './resources/css/common.css'
import './resources/css/progressbar.css'
import './resources/css/loader.css'

import { registerAudioPlayerStore } from './components/miniPlayer/AudioPlayer/playerActions'
import { QbBusiness } from './utils/business/qbbusiness'

injectTapEventPlugin()

if (window.__ENVIRONMENT__ === 'production') console.log = () => {
}

const areIntlLocalesSupported = require('intl-locales-supported')
const localesMyAppSupports = ['en', 'de', 'fr', 'es', 'it', 'pl']

function main() {
	if (global.Intl) {
		// Determine if the built-in `Intl` has the locale data we need.
		if (!areIntlLocalesSupported(localesMyAppSupports)) {
			// `Intl` exists, but it doesn't have the data we need, so load the
			// polyfill and patch the constructors we need with the polyfill's.
			const IntlPolyfill = require('intl')
			Intl.NumberFormat = IntlPolyfill.NumberFormat
			Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat
		}
	} else {
		// No `Intl`, so use and load the polyfill.
		global.Intl = require('intl')
		require('intl/locale-data/jsonp/en.js')
		require('intl/locale-data/jsonp/de.js')
		require('intl/locale-data/jsonp/fr.js')
		require('intl/locale-data/jsonp/es.js')
		require('intl/locale-data/jsonp/it.js')
		require('intl/locale-data/jsonp/pl.js')
	}

	addLocaleData([...fr, ...en, ...de, ...es, ...it, ...pl])
	const formats = {
		date: {
			datetime: {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric',
				hour: 'numeric',
				minute: 'numeric'
			}
		}
	}
	let locale
	let messages
	switch (navigator.language.split('-', 1)[0]) {
		case 'fr':
			locale = 'fr'
			messages = QbMessages.fr
			break
		case 'de':
			locale = 'de'
			messages = QbMessages.de
			break
		case 'es':
			locale = 'es'
			messages = QbMessages.es
			break
		case 'it':
			locale = 'it'
			messages = QbMessages.it
			break
		case 'pl':
			locale = 'pl'
			messages = QbMessages.pl
			break
		case 'en':
		default:
			locale = 'en'
			messages = QbMessages.en
	}
	const intlConfig = {
		locale,
		formats: {
			...formats,
		},
		defaultLocale: 'en',
		defaultFormats: {
			...formats
		},
		messages
	}

	const store = configureStore({})
	QbBusiness.setReduxDispatcher(store.dispatch)
	registerAudioPlayerStore(store)
	const history = syncHistoryWithStore(browserHistory, store)
	const routes = routesFactory()

	ReactDOM.render(
		<Provider store={store}>
			<IntlProvider {...intlConfig}>
				<Router history={history} routes={routes} />
			</IntlProvider>
		</Provider>,
		document.getElementById('root')
	)
}

main()



// WEBPACK FOOTER //
// ./src/index.js